// extracted by mini-css-extract-plugin
export default {"imageContainer":"Page_imageContainer__QBdE4","image":"Page_image__MBV6w","contentContainer":"Page_contentContainer__H5K2Y","title":"Page_title__SM2AH"};